import { createSelector } from '@ngrx/store';
import { surveyCreationFeature } from '../survey-creation.feature';

const { selectInsights } = surveyCreationFeature;

//SECTION SCORE
export const selectScorePercentage = createSelector(
  selectInsights,
  ({ score }) => score.scorePercentage,
);

export const selectScoreLoading = createSelector(
  selectInsights,
  ({ score }) => score.loading,
);

export const selectScoreError = createSelector(
  selectInsights,
  ({ score }) => score.error,
);
//!SECTION

//SECTION FEASIBILITY
export const selectFeasibilityTotal = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.total,
);

export const selectFeasibilityQuotaGroups = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.quotaGroups,
);

export const selectFeasibilityAudience = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.audience,
);

export const selectFeasibilityHasQuota = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.hasQuota,
);

export const selectFeasibilityLoading = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.loading,
);

export const selectFeasibilityError = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.error,
);

export const selectFeasibilityWithExclusions = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.withExclusions,
);

export const selectAdvancedFilters = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.advancedFilters,
);

export const selectAdvancedFiltersLookup = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.advancedFiltersLookup,
);

export const selectAdvancedFiltersLoading = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.advancedFiltersLookup.loading,
);

// Union of `manualGroups` and `criteriaSurveySummaries`. `manualGroups` stays empty until
// Apply commits it — the drawer's own local edit state (manual picks, removals) isn't synced
// to the store before then; that plumbing belongs to Apply, not this selector.
// TODO  Update when Apply exists
export const selectAdvancedFilterSurveyGroups = createSelector(
  selectAdvancedFilters,
  selectAdvancedFiltersLookup,
  ({ manualGroups }, { criteriaSurveySummaries }) => {
    const byId = new Map(
      [...manualGroups, ...criteriaSurveySummaries].map((survey) => [
        survey.id,
        survey,
      ]),
    );
    return [...byId.values()];
  },
);

export const selectHasExclusionList = createSelector(
  selectAdvancedFilterSurveyGroups,
  (advancedFilterSurveyGroups) => advancedFilterSurveyGroups.length > 0,
);

export const selectDisplayedFeasibility = createSelector(
  selectFeasibilityTotal,
  selectFeasibilityQuotaGroups,
  selectFeasibilityAudience,
  selectFeasibilityHasQuota,
  selectFeasibilityWithExclusions,
  selectAdvancedFilters,
  (total, quotaGroups, audience, hasQuota, withExclusions, advancedFilters) =>
    advancedFilters.excludeFromFeasibleAudience && withExclusions
      ? withExclusions
      : { total, quotaGroups, audience, hasQuota },
);

export const selectFeasibilityCpi = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.cpi,
);

export const selectFeasibilitySuppliers = createSelector(
  selectInsights,
  ({ feasibility }) => feasibility.suppliers,
);
//!SECTION

//SECTION FLEXIBILITY PRICES
export const selectFlexibilityPrices = createSelector(
  selectInsights,
  ({ flexibilityPrices }) => flexibilityPrices.prices,
);

export const selectFlexibilityPricesError = createSelector(
  selectInsights,
  ({ flexibilityPrices }) => flexibilityPrices.error,
);
//!SECTION

//SECTION PRICING
export const selectPricing = createSelector(
  selectInsights,
  ({ pricing }) => pricing,
);
//!SECTION
